import {
    LineChart,
    Line,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    LabelList
} from 'recharts'
import React, {Fragment, useEffect, useState} from 'react'
import { fetchWithAuth, getCSRFToken } from '../auth'
import {
    Accordion,
    AccordionAccordion,
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHeader,
    TableHeaderCell,
    Input,
    Radio,
    Modal,
    ModalContent,
    Button,
    List,
    ListItem,
    ListHeader, Icon
} from 'semantic-ui-react'
import { LoadingWrapper } from '../common'
import DatePicker from 'react-datepicker'
import { useNavigate, Link } from 'react-router-dom'
import {capitalizeFirstLetter, statusMap} from '../common/helpers'
import { PreviousReadinessModal } from '../Onestop/PreviousReadinessModal'
import { getTeamReadinessReport, getTeamDetails, getTeams } from '../common/apiClient'
import { teamSubmitsReadiness } from '../common/teamSettings'
import './Readiness.css'
import {createReadinessExcelReport} from "../../utils/excelHelper";

function toISOStringWithTimezone(date) {
    const tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
    const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1)
    return localISOTime
}

const useScreenSize = () => {
      const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });

      useEffect(() => {
        const handleResize = () => {
          setScreenSize({
            width: window.innerWidth,
            height: window.innerHeight,
          });
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
      }, []);

      return screenSize;
};
const TeamReadinessNoReportTable = props => {
    const navigate = useNavigate()
    return props.rows.length ? <Table celled striped unstackable textAlign="center">
        <TableHeader>
            <TableRow>
                <TableHeaderCell>Team</TableHeaderCell>
            </TableRow>
        </TableHeader>
        <TableBody>
            {props.rows.map((row, index) => {
                return <TableRow key={"team" + index}>
                    <TableCell>
                        <Link onClick={() => {
                                navigate('/teams/' + row.info.id + '/view')
                        }} style={{ fontWeight: "bold" }}>{row.info.name}</Link>
                    </TableCell>
                </TableRow>
            })}
        </TableBody>
    </Table> : "No data"
}

const TeamReadinessTable = props => {
    const navigate = useNavigate()
    const screenSize = useScreenSize();
    const isMobile = screenSize.width < 768;
    return props.rows.length ?
        <Fragment>
            <Table celled striped unstackable textAlign="center" style={{fontSize: isMobile ? '0.8em' : '1em', width: '100%'}}>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Team</TableHeaderCell>
                        <TableHeaderCell>Status</TableHeaderCell>
                        <TableHeaderCell>Reported by</TableHeaderCell>
                        <TableHeaderCell>Reason</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {props.rows.map((row, index) => {
                        const statusReasonStr = row.statusReason.replaceAll('\'', '"')
                        return <TableRow key={"team" + index}>
                            <TableCell>
                                <Link onClick={() => {
                                    if(row.status === 'noReport') {
                                        navigate('/teams/' + row.info.id + '/view')
                                    } else {
                                        props.setSelected(row.info.id, row.id)
                                    }
                                }} style={{ fontWeight: "bold" }}>{row.info.name}</Link>
                            </TableCell>
                            <TableCell>
                                <div>
                                    {row.status === 'ready' ? 'Ready' : row.status === 'not_ready' ? 'Not ready' : 'N/A'}
                                </div>
                                <div>
                                    {row.status === 'noReport' ? '' : toISOStringWithTimezone(new Date(row.creationTime)).split('T')[1].substring(0, 8)}
                                </div>
                            </TableCell>
                            <TableCell>
                                <Link to={'/members/' + row.createdBy.id + '/view'}>{row.createdBy.name}</Link>
                            </TableCell>
                            <TableCell>
                                {statusReasonStr ?
                                    <span>{statusReasonStr.split(',').map((val) => statusMap[val] ? statusMap[val] : val).join(", ")}</span>
                                    : <span style={{ color: "gray" }}>No reason</span>}</TableCell>
                        </TableRow>
                    })}
                </TableBody>
            </Table>
        </Fragment>: "No data"
}

const AssetReadinessTable = props => {
    const screenSize = useScreenSize();
    const isMobile = screenSize.width < 768;
    return props.rows.length ? <Table celled striped unstackable textAlign="center" style={{fontSize: isMobile ? '0.8em' : '1em', width: '100%'}}>
        <TableHeader>
            <TableRow>
                <TableHeaderCell>Asset</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Reported by</TableHeaderCell>
                <TableHeaderCell>Reason</TableHeaderCell>
            </TableRow>
        </TableHeader>
        <TableBody>
            {props.rows.map((row, index) => {
                return <TableRow key={"asset" + index}>
                    <TableCell>
                        <Link onClick={() => props.setSelected(row.info.id)} style={{ fontWeight: "bold" }}>{row.info.name}</Link>
                    </TableCell>
                    <TableCell>
                        <div>
                            {row.status === 'ready' ? 'Ready' : 'Not ready'}
                        </div>
                        <div>
                            {toISOStringWithTimezone(new Date(row.creationTime)).split('T')[1].substring(0, 8)}
                        </div>
                    </TableCell>
                    <TableCell>
                        <Link to={'/members/' + row.createdBy.id + "/view"}>{row.createdBy.name}</Link>
                    </TableCell>
                    <TableCell>{statusMap[row.statusReason] ? statusMap[row.statusReason] : row.statusReason}</TableCell>
                </TableRow>
            })}
        </TableBody>
    </Table> : "No data"
}

const MemberReadinessTable = props => {
    const screenSize = useScreenSize();
    const isMobile = screenSize.width < 768;
    return props.rows.length ? <Table celled striped unstackable textAlign="center" style={{fontSize: isMobile ? '0.8em' : '1em', width: '100%'}}>
        <TableHeader>
            <TableRow>
                <TableHeaderCell>Member</TableHeaderCell>
                <TableHeaderCell>Status</TableHeaderCell>
                <TableHeaderCell>Reported by</TableHeaderCell>
                <TableHeaderCell>Reason</TableHeaderCell>
            </TableRow>
        </TableHeader>
        <TableBody>
            {props.rows.map((row, index) => {
                return <TableRow key={"member" + index}>
                    <TableCell>
                        <Link onClick={() => props.setSelected(row.info.id)} style={{ fontWeight: "bold" }}>{row.info.name}</Link>
                    </TableCell>
                    <TableCell>
                        <div>
                            {row.status === 'ready' ? 'Ready' : 'Not ready'}
                        </div>
                        <div>
                            {toISOStringWithTimezone(new Date(row.creationTime)).split('T')[1].substring(0, 8)}
                        </div>
                    </TableCell>
                    <TableCell>
                        <Link to={'/members/' + row.createdBy.id + "/view"}>{row.createdBy.name}</Link>
                    </TableCell>
                    <TableCell>{statusMap[row.statusReason] ? statusMap[row.statusReason] : row.statusReason}</TableCell>
                </TableRow>
            })}
        </TableBody>
    </Table> : "No data"
}

export const IndividualReadinessReport = props => {
    const [teams, setTeams] = useState([])
    const [teamsLoaded, setTeamsLoaded] = useState(false)
    const [fullReport, setFullReport] = useState([])
    const [reportDataByDate, setReportDataByDate] = useState([])
    const [linechartData, setLineChartData] = useState([])
    const [dayPanels, setDayPanels] = useState([])
    const [chosenRange, setChosenRange] = useState('today')
    const [customStart, setCustomStart] = useState(new Date())
    const [customEnd, setCustomEnd] = useState(new Date())
    const [selectedReadiness, setSelectedReadiness] = useState(null)
    const [selectedReadinessTable, setSelectedReadinessTable] = useState({})
    const [idToPieChartData, setIdToPieChartData] = useState({})
    const [pieData, setPieData] = useState([])
    const [sortedReadiness, setSortedReadiness] = useState([])
    const [loaded, setLoaded] = useState(false)
    const navigate = useNavigate()

    const [isLandscape, setIsLandscape] = useState(window.matchMedia('(orientation:landscape)').matches)
    const updateLandscape = () => {
        setIsLandscape(window.matchMedia('(orientation:landscape)').matches)
    }
    window.addEventListener('resize', updateLandscape)

    const exportReadinessData = async () => {
        const readinessType = props.type
        await createReadinessExcelReport(readinessType, reportDataByDate)
    }

    function isOneDay() {
        return chosenRange === 'today' || (
            customStart && customEnd && chosenRange === 'custom' && customEnd - customStart < 24 * 60 * 60 * 1000)
    }

    async function setReadinessInfoTeam(id) {
        if (props.type === 'team') {
            const teamReadiness = await getTeamReadinessReport(id)
            setSelectedReadinessTable(teamReadiness)
        }
    }

    function getIdToPieChartData(fullReport) {
        const idToPieChartData = {}
        for (const id in fullReport) {
            if (!(id in idToPieChartData)) {
                idToPieChartData[id] = [
                    {
                        name: 'Ready',
                        value: 0
                    },
                    {
                        name: 'Not ready',
                        value: 0
                    }
                ]
            }
            for (const report of fullReport[id]) {
                if (report['status'] === 'ready') {
                    idToPieChartData[id][0]['value']++
                } else {
                    idToPieChartData[id][1]['value']++
                }
            }
        }

        return idToPieChartData
    }

    function getPieData(dateToReady) {
        let numReady = 0
        let numNotReady = 0
        let numNoReport = 0
        for(const [, report] of Object.entries(dateToReady)) {
            numReady += report.ready.length
            numNotReady += report.notReady.length
            if(props.type === 'team') {
                numNoReport += report.noReport?.length
            }
        }

        const pieData = [
            {
                name: 'Ready',
                value: numReady
            },
            {
                name: 'Not ready',
                value: numNotReady
            }
        ]

        if(props.type === 'team') {
            pieData.push(
                {
                    name: 'No report',
                    value: numNoReport
                })
        }
        return pieData
    }

    function getSortedReadiness(fullReport) {
        const individualCounts = {}
        for (const id in fullReport) {
            let thisNumReady = 0
            let thisNumNotReady = 0
            for (const report of fullReport[id]) {
                if (report['status'] === 'ready') {
                    thisNumReady++
                } else {
                    thisNumNotReady++
                }
                individualCounts[id] = {
                    ready: thisNumReady,
                    notReady: thisNumNotReady
                }
            }
        }
        const sortedKeys = Object.keys(fullReport).sort((x, y) => {
            const ratioX = individualCounts[x].ready / (individualCounts[x].ready + individualCounts[x].notReady)
            const ratioY = individualCounts[y].ready / (individualCounts[y].ready + individualCounts[y].notReady)
            return ratioX - ratioY
        })
        return sortedKeys.map((id) => {
            return {
                name: fullReport[id][0]?.info.name,
                id: id,
                readinessId:fullReport[id][0]?.id,
                reason: fullReport[id][0]?.statusReason,
                notes: fullReport[id][0]?.notes,
                'Ready': individualCounts[id].ready,
                'Not ready': individualCounts[id].notReady
            }
        })
    }

    function getDateToReady(fullReport) {
        const dateToReady = {}
        for (const id in fullReport) {
            for (const report of fullReport[id]) {
                const reportDate = toISOStringWithTimezone(new Date(report['creationTime'])).split('T')[0]
                if (!(reportDate in dateToReady)) {
                    dateToReady[reportDate] = {
                        date: reportDate,
                        'ready': [],
                        'notReady': []
                    }
                }
                if (report['status'] === 'ready') {
                    dateToReady[reportDate]['ready'].push(report)
                } else {
                    dateToReady[reportDate]['notReady'].push(report)
                }
            }
        }
        if(props.type === 'team') {
            for(const date of Object.keys(dateToReady)) {
                let teamsCopy = structuredClone(teams)
                for(const report of [...dateToReady[date]['ready'], ...dateToReady[date]['notReady']]) {
                    teamsCopy = teamsCopy.filter((team) => team.id !== report.info.id)
                }
                dateToReady[date]['noReport'] = teamsCopy.map((team) => {
                    return {
                        id: null,
                        info: team,
                        statusReason: "",
                        status: "noReport",
                        creationTime: "",
                        createdBy: {
                            id: null,
                            name: null
                        }
                    }
                })
            }
        }
        return dateToReady
    }

    function getLinechartData(dateToReady) {
        if (Object.keys(dateToReady).length === 1) {
            const onlyDate = Object.keys(dateToReady)[0]
            if (!onlyDate) {
                return []
            }
            const duplicatedReady = structuredClone(dateToReady[onlyDate]['ready'])
            const duplicatedNotReady = structuredClone(dateToReady[onlyDate]['notReady'])
            let numReady = 0
            let numNotReady = 0
            let numNoReport = teams.length
            const awaitingReports = new Set(teams.map(team => team.id))
            const linechartData = []
            for (const report of duplicatedReady.concat(duplicatedNotReady).sort((a, b) => a.creationTime.localeCompare(b.creationTime))) {
                if (awaitingReports.delete(report.info.id)) numNoReport--
                if (report.status === 'ready') {
                    numReady++
                } else {
                    numNotReady++
                }
                linechartData.push({
                    date: new Date(report.creationTime),
                    'Ready': numReady,
                    'Not ready': numNotReady,
                    'No report': numNoReport
                })
            }
            return linechartData
        } else {
            const linechartData = Object.keys(dateToReady).sort().map((date) => {
                const result = {
                    'date': new Date(date),
                    'Ready': dateToReady[date].ready.length,
                    'Not ready': dateToReady[date].notReady.length
                }
                if(props.type === 'team') {
                    result['No report'] = dateToReady[date].noReport.length
                }
                return result
            })
            return linechartData
        }
    }

    function getDayPanels(dateToReady) {
        const ReadinessTable = props.type === 'team' ? TeamReadinessTable : props.type === 'asset' ? AssetReadinessTable : MemberReadinessTable
        const generateDayPanel = (date) => {
            const accordionPanels = [
                {
                    key: 'ready' + date,
                    title: 'Ready (' + (dateToReady[date].ready?.length ?? 0) + ')',
                    content: {
                        content: <ReadinessTable
                            setSelected={(id, readinessId) => { setSelectedReadiness(id); setReadinessInfoTeam(readinessId); }}
                            rows={dateToReady[date] ? dateToReady[date].ready : []} />
                    }
                },
                {
                    key: 'notready' + date,
                    title: 'Not ready (' + (dateToReady[date].notReady?.length ?? 0) + ')',
                    content: {
                        content: <ReadinessTable
                            setSelected={(id, readinessId) => { setSelectedReadiness(id); setReadinessInfoTeam(readinessId); }}
                            rows={dateToReady[date] ? dateToReady[date].notReady : []} />
                    }
                }
            ]

            if(props.type === 'team') {
                accordionPanels.push(
                    {
                        key: 'noreport' + date,
                        title: 'No Report (' + (dateToReady[date].noReport?.length ?? 0) + ')',
                        content: {
                            content: <TeamReadinessNoReportTable
                                setSelected={(id, readinessId) => { setSelectedReadiness(id); setReadinessInfoTeam(readinessId); }}
                                rows={dateToReady[date] ? dateToReady[date].noReport : []} />
                        }
                    }
                )
            }

            const dayPanel = {
                key: date,
                title: date,
                content: {
                    content: <AccordionAccordion panels={accordionPanels} />
                }
            }

            return dayPanel
        }
        const dayPanels = Object.keys(dateToReady).sort((a, b) => b.localeCompare(a)).map(generateDayPanel)

        return dayPanels
    }

    function dedupeReport(fullReport) {
        const filteredReport = {}
        const lastDateForId = {}
        for (const id in fullReport) {
            filteredReport[id] = fullReport[id].slice().reverse().filter((value) => {
                const reportTime = new Date(value.creationTime)
                const reportDate = toISOStringWithTimezone(reportTime).split('T')[0]
                if (reportDate !== lastDateForId[id]) {
                    lastDateForId[id] = reportDate
                    return true
                }
                return false
            })
            if (!filteredReport[id].length) {
                delete filteredReport[id]
            }
        }
        return filteredReport
    }


    const updateReadinessReport = () => {
        const dedupedData = dedupeReport(fullReport)

        const idToPieChartData = getIdToPieChartData(dedupedData)
        setIdToPieChartData(idToPieChartData)

        const sortedReadiness = getSortedReadiness(dedupedData)
        setSortedReadiness(sortedReadiness)

        const dateToReady = getDateToReady(dedupedData)
        const linechartData = getLinechartData(dateToReady)
        setLineChartData(linechartData)

        setReportDataByDate(dateToReady)

        const dayPanels = getDayPanels(dateToReady)
        setDayPanels(dayPanels)

        const pieData = getPieData(dateToReady)
        setPieData(pieData)
    }

    async function updateFullReport(start, end) {
        setFullReport([])
        setLoaded(false)
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'readiness/' + props.type +
                                        '?start=' + start.toISOString() + '&end=' + end.toISOString(),
            {
                headers: { 'X-CSRFToken': getCSRFToken() },
                credentials: 'include'
            }
        )
        const respJson = await resp.json()
        setFullReport(respJson)
        setLoaded(true)
    }

    async function getAllTeams() {
        setLoaded(false)
        setTeamsLoaded(false)
        const respJson = await getTeams()
        const detailedTeams = await Promise.all(respJson.map(async team => {
            try {
                const details = await getTeamDetails(team.id)
                return details?.id ? { ...team, ...details } : null
            } catch {
                return null
            }
        }))
        setTeams(detailedTeams.filter(team => team && teamSubmitsReadiness(team)))
        setTeamsLoaded(true)
        setLoaded(true)
    }

    useEffect(() => {
        if(teamsLoaded && fullReport) {
            updateReadinessReport()
        }
    }, [fullReport, teamsLoaded])

    useEffect(() => {
        let start = new Date(0)
        let end = new Date()
        end.setHours(23, 59, 59, 999)
        const numStrToNum = {
            'ten': 10,
            'thirty': 30
        }
        if (chosenRange === 'ten' || chosenRange === 'thirty') {
            const startDate = new Date()
            startDate.setDate(startDate.getDate() - numStrToNum[chosenRange])
            startDate.setHours(0, 0, 0, 0)
            start = startDate
        } else if (chosenRange === 'custom') {
            const startDate = new Date()
            startDate.setDate(startDate.getDate() - 1)
            startDate.setHours(0, 0, 0, 0)
            start = startDate
        }
        if (chosenRange === 'today') {
            const startDate = new Date()
            startDate.setHours(0, 0, 0, 0)
            start = startDate
        }

        if (chosenRange !== 'custom') {
            updateFullReport(start, end)
        } else {
            updateFullReport(customStart, customEnd)
        }
    }, [chosenRange, props.type])

    useEffect(() => {
        if(props.type === 'team') {
            getAllTeams()
        }
    }, [props.type])

    const changeChosenRange = (e, { value }) => {
        setChosenRange(value)
    }

    const handleCustomDateChange = (dates) => {
        const [start, end] = dates;
        setCustomStart(start);
        setCustomEnd(end);
        if (start && end) {
            start.setHours(0, 0, 0, 0)
            end.setHours(23, 59, 59, 999)
            updateFullReport(start, end)
        }
    }

    return (
        <LoadingWrapper loading={!loaded} text="Generating report">
            <div className="individual-readiness-wrapper">
                {selectedReadiness ?
                    <Modal open={true} size={"small"}>
                        <ModalContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div style={{ fontWeight: "bold" }}>
                                {chosenRange === 'thirty' ? 'Last 30 days' :
                                    chosenRange === 'ten' ? 'Last 10 days' :
                                        chosenRange === 'all' ? 'All time' :
                                            chosenRange === 'today' ? 'Today' :
                                                chosenRange === 'custom' ? toISOStringWithTimezone(customStart).split('T')[0] + " - " + toISOStringWithTimezone(customEnd).split('T')[0] : ""}
                            </div>
                            <ResponsiveContainer width="100%" height={250}  >
                                <PieChart width={730} height={250}>
                                    <Pie animationDuration={500} data={idToPieChartData[selectedReadiness]} label={entry => entry.name + " (" + entry.value + ")"} dataKey="value" nameKey="name" cx="50%" cy="50%" outerRadius={50} fill="#8884d8">
                                        <LabelList dataKey="showValue" position="insideRight" />
                                        {idToPieChartData[selectedReadiness].map((entry) => {
                                            return <Cell key={entry.name} fill={entry.name === 'Ready' ? '#00aaff' : '#ff0000'} />
                                        })}
                                    </Pie>
                                </PieChart>
                            </ResponsiveContainer>
                            {props.type === 'team' && <><div style={{ fontWeight: "bold", marginBottom: "0.5rem", textDecoration: "underline" }}>
                                Selected report
                            </div>
                            <PreviousReadinessModal
                                members={selectedReadinessTable.members}
                                assets={selectedReadinessTable.assets}
                                team={selectedReadinessTable.team}
                            /></>}
                            <div style={{marginTop: "2rem"}}>
                                <Button onClick={() => navigate(props.type === 'team' ? '/teams/' + selectedReadiness + "/view"
                                    : props.type === 'asset' ? '/assets/' + selectedReadiness + '/view'
                                        : '/members/' + selectedReadiness + "/view")}>View</Button>
                                <Button onClick={() => setSelectedReadiness(null)}>Close</Button>
                            </div>
                        </ModalContent>
                    </Modal> : <></>}
                <div className="individual-readiness-chart">
                    <div className="daterange-wrapper">
                        <Radio className="radio-button"
                            label="All"
                            value="all"
                            checked={chosenRange === 'all'}
                            onChange={changeChosenRange} />
                        <Radio
                            className="radio-button"
                            label="Last 30 days"
                            value="thirty"
                            checked={chosenRange === 'thirty'}
                            onChange={changeChosenRange} />
                        {isLandscape && <Radio
                            className="radio-button"
                            label="Last 10 days"
                            value="ten"
                            checked={chosenRange === 'ten'}
                            onChange={changeChosenRange} />}
                        <Radio
                            className="radio-button"
                            label="Today"
                            value="today"
                            checked={chosenRange === 'today'}
                            onChange={changeChosenRange} />
                        <Radio
                            className="radio-button"
                            label="Custom range"
                            value="custom"
                            checked={chosenRange === 'custom'}
                            onChange={changeChosenRange} />
                    </div>
                    {chosenRange === 'custom' && <DatePicker
                        selected={customStart}
                        onChange={handleCustomDateChange}
                        startDate={customStart}
                        endDate={customEnd}
                        customInput={<Input style={{ marginBottom: "1rem" }} icon='calendar' />}
                        selectsRange
                    />}
                    {pieData.length > 0 && linechartData.length > 0 && sortedReadiness.length > 0 && dayPanels.length > 0 ?
                        <Fragment>
                            <div className="piechart-row">
                                <ResponsiveContainer width={isLandscape ? "45%" : "100%"} height={250}>
                                    <PieChart width={900} height={250}>
                                        <Pie
                                            data={pieData}
                                            label={entry => entry.name + " (" + entry.value + ")"}
                                            labelLine={false}
                                            dataKey="value"
                                            nameKey="name"
                                            cx="50%"
                                            cy="50%"
                                            outerRadius={isLandscape ? 90 : 60}
                                            fill="#8884d8"
                                            animationDuration={500}>
                                            <LabelList dataKey="showValue" position="insideRight"/>
                                            {pieData.map((entry) => {
                                                return <Cell key={entry.name}
                                                             fill={entry.name === 'Ready' ? '#00aaff' : entry.name === 'No report' ? '#aaaaaa' : '#ff0000'}/>
                                            })}
                                        </Pie>
                                    </PieChart>
                                </ResponsiveContainer>
                                <div>
                                    <List celled style={{margin: "1rem"}}>
                                        <ListHeader style={{fontWeight: "bold"}}>
                                            {"Worst % in Ready"}
                                        </ListHeader>
                                        {sortedReadiness.filter((val) => {
                                            return val['Not ready'] > 0
                                        }).map((val, index) => {
                                            return <ListItem as='a'
                                                             style={{fontWeight: "bold"}}
                                                             onClick={() => {setSelectedReadiness(val.id); setReadinessInfoTeam(val.readinessId)}}
                                                             key={val.id}>
                                                <span style={{color: "gray"}}>{index + 1 + ". "}</span>
                                                {val.name}
                                            </ListItem>
                                        })}
                                    </List>
                                </div>
                                <div>
                                    <List celled style={{margin: "1rem"}}>
                                        <ListHeader style={{fontWeight: "bold"}}>
                                            {"Best % in Ready"}
                                        </ListHeader>
                                        {sortedReadiness.filter((val) => {
                                            return val['Ready'] > 0
                                        }).reverse().map((val, index) => {
                                            return <ListItem as='a'
                                                             style={{fontWeight: "bold"}}
                                                             onClick={() => {setSelectedReadiness(val.id); setReadinessInfoTeam(val.readinessId)}}
                                                             key={val.id}>
                                                <span style={{color: "gray"}}>{index + 1 + ". "}</span>
                                                {val.name}
                                            </ListItem>
                                        })}
                                    </List>
                                </div>
                            </div>
                            <ResponsiveContainer className="line-chart-wrapper" width="100%" height={250}>
                                <LineChart data={linechartData}
                                           margin={{top: 5, right: 5, left: 5, bottom: 5}}>
                                    <CartesianGrid strokeDasharray="3 3"/>
                                    <XAxis
                                        dataKey="date"
                                        type="number"
                                        tickFormatter={isOneDay() ? (item) => new Date(item).toLocaleTimeString() : (item) => new Date(item).toLocaleDateString()}
                                        domain={linechartData.length ?
                                            [
                                                (new Date(linechartData[0]['date']).getTime()),
                                                (new Date(linechartData[linechartData.length - 1]['date']).getTime())
                                            ] : []
                                        }
                                    />
                                    <YAxis allowDecimals={false}/>
                                    <Tooltip
                                        labelFormatter={(value) => (isOneDay() ? new Date(value).toLocaleTimeString() : new Date(value).toLocaleDateString())}/>
                                    <Legend/>
                                    <Line animationDuration={150} type="monotone" dataKey="Ready" stroke="#00aaff"
                                          dot={linechartData.length < 15}/>
                                    <Line animationDuration={150} type="monotone" dataKey="Not ready" stroke="#ff0000"
                                          dot={linechartData.length < 15}/>
                                    {props.type === 'team' &&
                                        <Line animationDuration={150} type="monotone" dataKey="No report"
                                              stroke="#aaaaaa" dot={linechartData.length < 15}/>}
                                </LineChart>
                            </ResponsiveContainer>
                            <div className="accordion-wrapper">
                                <div style={{fontWeight: "bold", marginBottom: "2rem", fontSize: "2rem"}}>
                                    Daily reports
                                </div>
                                <div style={{marginBottom: "2rem"}}>
                                    <Button
                                        size='small'
                                        style={{backgroundColor: '#258e54', color: 'white'}}
                                        onClick={() => exportReadinessData()}
                                    >
                                        <Icon name='download'/>
                                        Export {capitalizeFirstLetter(props.type)} Readiness
                                    </Button>
                                </div>
                                {dayPanels.length ?
                                    <Fragment>
                                        <Accordion defaultActiveIndex={0} panels={dayPanels} styled/>
                                    </Fragment> : "No data"}
                            </div>
                        </Fragment>
                        : <h3>{capitalizeFirstLetter(props.type)} readiness data was not found for the given time range</h3>
                    }
                </div>
            </div>
        </LoadingWrapper>
    )
}
